import classNames from "lib/classNames";

export default function LoadingSkeleton({
  className = "",
}: {
  className?: string;
}) {
  return (
    <div
      className={classNames(
        "animate-pulse bg-muted bg-gray-200 dark:bg-gray-600",
        className
      )}
    />
  );
}
